import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import IncotermService from "../../services/incoterm/IncotermService";
import { loadingIncotermDropdown } from "../../store/slices/incoterm/incotermSlice";

export const useIncoterm = () => {
  const dispatch: AppDispatch = useDispatch();

  const { incotermDropdown } = useSelector(
    (state: RootState) => state.incoterm
  );

  const fetchIncoterms = async () => {
    try {
      const response = await IncotermService.fetchDropdown();

      const { data, statusCode } = response;

      if (statusCode === 200) {
        dispatch(loadingIncotermDropdown(data));
      }
    } catch (error) {
      console.error("Error al cargar incoterms:", error);
    }
  };

  return {
    incotermDropdown,
    fetchIncoterms,
  };
};
